<template>
  <v-toolbar app>
    <v-toolbar-title class="headline text-uppercase">
      <router-link :to="{name: 'home'}" class="title_link">
        <span class="mr-3">Cocturachef</span>
        <span class="font-weight-light">Administration</span>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-btn flat :to="{name: 'ovens'}">
      <span class="mr-2">Fours</span>
    </v-btn>

    <v-btn flat :to="{name: 'users'}">
      <span class="mr-2">Utilisateurs</span>
    </v-btn>

    <v-spacer></v-spacer>

    <v-btn color="primary" flat :to="{name: 'firmware'}" v-if="role == 'SUPER_ADMIN'">
      <span class="mr-2">Firmware</span>
    </v-btn>

    <v-btn color="primary"  flat :to="{name: 'live'}">
      <span class="mr-2">Supervision (dev)</span>
    </v-btn>

    <v-btn color="primary"  flat :to="{name: 'virtual'}" v-if="role == 'SUPER_ADMIN'">
      <span class="mr-2">Four virtuel</span>
    </v-btn>

    <span v-if="userData">{{ userData.name }}</span>

    <v-btn icon @click="logout()">
      <v-icon>logout</v-icon>
    </v-btn>

    <!--
    <v-btn flat :to="{name: 'help'}">
      <span class="mr-2">Aide</span>
    </v-btn>
    -->
  </v-toolbar>
</template>

<script>
import jwtDecode from "jwt-decode";
export default {
  name: "Menu",
  components: {},
  data() {
    return {};
  },
  computed: {
    jwt() {
      return this.$store.state.jwt;
    },
    role() {
      if (this.userData) {
        return this.userData.role;
      }
      return "GUEST";
    },
    userData() {
      if (this.jwt) {
        return jwtDecode(this.jwt);
      }
    }
  },
  methods: {
    // logout
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<style>
.title_link {
  text-decoration: none;
  color: #ba0a15;
}
</style>